import { useContext } from 'react'
import { DataContext } from '../context/DataContext'
import { normalizeRegionName, regionCode } from '../helpers/addressParser'

export const useWoocommerce = () => {
  const {
    userInfo,
    addressInfo,
    setEcommerceInfo,
    ecommerceInfo,
    setCartData,
    setAddressInfo,
    setSteps,
    steps,
    setIsPaying,
    setCurrentStep,
    setSelectedShippingMethod,
    billingInfo,
    setBillingInfo,
    setUserInfo,
    setSelectedServiceType
  } = useContext(DataContext)

  const setInitialInformationWoocommerce = message => {
    const { cms, currentUrl, cartItems } = message
    if (cms !== 'woocommerce' && cms !== 'woocommerce-redirect') return
    setEcommerceInfo(prevState => {
      return { ...prevState, cms, currentUrl, cartItems }
    })
    const totalPrice = cartItems.reduce(
      (sum, { lineTotal }) => sum + Number(lineTotal),
      0
    )
    const totalCount = cartItems.reduce(
      (sum, { quantity }) => sum + quantity,
      0
    )
    const totalWeight = cartItems.reduce((sum, { weight }) => {
      if (weight !== null || weight !== undefined) {
        return sum + parseFloat(weight)
      }
      return sum
    }, 0)
    setCartData(prevState => {
      return {
        ...prevState,
        total: Math.trunc(totalPrice),
        subtotal: Math.trunc(totalPrice),
        lines: cartItems,
        itemsCount: totalCount,
        totalWeight: totalWeight ? Math.ceil(totalWeight) : 1
      }
    })
  }

  const iframeLoadedWoocommerce = () => {
    setTimeout(() => {
      window.parent.postMessage(
        {
          type: 'iframe-mounted',
          origin: 'pinflag-checkout-iframe',
          message: true
        },
        '*'
      )
    }, 1500)
  }

  const redirectToHomeWoocommerce = () => {
    window.parent.postMessage(
      {
        type: 'redirect-to-home',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const wooCommerceClosePinmap = () => {
    window.parent.postMessage(
      {
        type: 'close-pinmap',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const hideWoocommerceSummary = () => {
    window.parent.postMessage(
      {
        type: 'edit-button',
        origin: 'pinflag-checkout-iframe',
        message: true
      },
      '*'
    )
  }

  const continueCheckout = (message) => {
    if (message.cms !== 'woocommerce') return
    setAddressInfo(prevState => {
      return {
        ...prevState,
        userAddress: message.formData.address,
        aditionalInfo: message.formData.aditionalInfo.split('|')[0],
        district: message.formData.city,
        deliveryType: message.formData.deliveryType,
        price: message.formData.postcode,
        serviceType: message.formData.serviceType,
        region: message.formData.region,
        mapCoords: message.formData.mapCoords,
        sla: message.formData.sla,
        serviceName: message.formData.serviceName
      }
    })
    setUserInfo(prevState => {
      return {
        ...prevState,
        email: message.formData.email,
        names: message.formData.firstname + ' ' + message.formData.lastname,
        phone: message.formData.phone,
        rut: message.formData.aditionalInfo.split('|')[1]
      }
    })
    setSelectedServiceType((prevState) => {
      return {
        ...prevState,
        description: message.formData.sla
      }
    })
    setBillingInfo((prevState) => {
      return {
        ...prevState,
        corporateName: message.formData.corporateName ? message.formData.corporateName : '',
        category: message.formData.corporateCategory ? message.formData.corporateCategory : '',
        corporateRut: message.formData.corporateRut ? message.formData.corporateRut : '',
        corporatePhone: message.formData.corporatePhone ? message.formData.corporatePhone : '',
        address: message.formData.corporateAddress ? message.formData.corporateAddress : '',
        district: message.formData.corporateDistrict ? message.formData.corporateDistrict : ''
      }
    })
    setSelectedShippingMethod(prevState => {
      return {
        ...prevState,
        selectedShippingMethod: message.formData.selectedShippingMethod
      }
    })
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    updatedSteps[1].subSteps[1].completed = true
    updatedSteps[1].subSteps[2].completed = true
    setCurrentStep(2)
    setSteps(updatedSteps)
    setIsPaying(true)
  }

  const shippingPostMessageWoocommerce = () => {
    if (ecommerceInfo.cms !== 'woocommerce' && ecommerceInfo.cms !== 'woocommerce-redirect') return
    const firstname = userInfo.names.substring(0, userInfo.names.indexOf(' '))
    const lastname = userInfo.names.substring(userInfo.names.indexOf(' ') + 1)
    window.parent.postMessage(
      {
        type: 'set-form-data',
        origin: 'pinflag-checkout-iframe',
        message: {
          firstname,
          lastname,
          address: addressInfo.userAddress,
          aditionalInfo: `${addressInfo.aditionalInfo}|${userInfo.rut}`,
          phone: userInfo.phone,
          email: userInfo.email,
          city: addressInfo.district,
          regionCode: `CL-${regionCode[normalizeRegionName(addressInfo.region)]}`,
          postcode: addressInfo.price,
          deliveryType: addressInfo.deliveryType,
          manualDelivery: addressInfo.manualDelivery,
          serviceType: `${addressInfo.courier && addressInfo.courier}${addressInfo.serviceType ? ` - ${addressInfo.serviceType}` : ''}`,
          region: addressInfo.region,
          mapCoords: addressInfo.mapCoords,
          corporateName: billingInfo.corporateName ? billingInfo.corporateName : '',
          corporateCategory: billingInfo.category ? billingInfo.category : '',
          corporateRut: billingInfo.corporateRut ? billingInfo.corporateRut : '',
          corporatePhone: billingInfo.corporatePhone ? billingInfo.corporatePhone : '',
          corporateAddress: billingInfo.address ? billingInfo.address : '',
          corporateDistrict: billingInfo.district ? billingInfo.district : '',
          sla: addressInfo.sla,
          serviceName: addressInfo.serviceName
        }
      },
      '*'
    )
  }

  return {
    setInitialInformationWoocommerce,
    iframeLoadedWoocommerce,
    shippingPostMessageWoocommerce,
    redirectToHomeWoocommerce,
    hideWoocommerceSummary,
    continueCheckout,
    wooCommerceClosePinmap
  }
}
